// For a while, the thinking was to use this in a bunch of blog posts whenever I needed an arrow, but really I haven't used it in years. It uses a raster iPad-drawn style I've avoided. Plus I can't change its color!
import * as React from 'react';
import { styled } from '@linaria/react';

const IMAGES = {
  straight1: '/images/arrow-straight-1.png',
  straight2: '/images/arrow-straight-2.png',
  straight3: '/images/arrow-straight-3.png',
  diagonal1: '/images/arrow-diagonal-1.png',
  diagonal2: '/images/arrow-diagonal-2.png',
  diagonal3: '/images/arrow-diagonal-3.png',
};

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  type: 'straight' | 'diagonal';
  variant?: 1 | 2 | 3;
  width: string;
  rotation?: string;
}

const Arrow = ({
  type,
  variant = 1,
  width,
  rotation,
  ...delegated
}: Props) => {
  const src = IMAGES[`${type}${variant}`];

  return <Elem alt="" src={src} style={{ width }} {...delegated} />;
};

const Elem = styled.img`
  display: block;
`;

export default Arrow;
